import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tooltip } from 'wix-style-react'
import * as _ from 'lodash'

import Text from 'components/common/Text'
import { TEAL } from '../../../../styles'

const Container = styled.div`
  position: relative;
  width: 30em;
  height: 30em;
  background-color: gold;
  margin-bottom: 1em;
`
const Image = styled.img`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  cursor: crosshair;
`
const Point = styled.div`
  width: 1.6em;
  height: 1.6em;
  position: absolute;
  top: -0.8em;
  left: -0.8em;
  border-radius: 50%;
  border: solid 0.5px #e8e8e8;
  background-color: ${props => props.isActive ? TEAL : '#000'} ;
  margin-left: ${props => props.left * 100 + '%'};
  margin-top: ${props => props.top * 100 + '%'};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

class InstaImage extends Component {

  onClick = (e) => {
    // console.log('onImageClick')
    e.preventDefault()
    const nEvent = e.nativeEvent
    const left = nEvent.offsetX / nEvent.target.width
    const top = nEvent.offsetY / nEvent.target.height
    this.props.createNewPoint(left, top)
  }

  onPointClick = (i) => {
    return (e) => {
      // console.log('onPointClick', i)
      this.props.setActivePoint(i)
    }
  }

  renderProductPoint = (product, i) => {
    // console.log('renderPoint', p, i)
    const p = product.point
    const title = _.get(product, ['info', 'title'], 'Not configured')
    return (
      <Tooltip
        key={i}
        active={false}
        placement='bottom'
        alignment='center'
        content={title}
        showTrigger='mouseenter'
        hideTrigger='mouseleave'
      >
        <Point
          key={i}
          left={p.left}
          top={p.top}
          onClick={this.onPointClick(i)}
          isActive={i === this.props.activePointIndex}
        >
          <Text color='white'>{i}</Text>
        </Point>
      </Tooltip>
    )
  }

  render () {
    const { image, products } = this.props
    return (
      <Container>
        <Image src={image} onClick={this.onClick} />
        {products.map(this.renderProductPoint)}
      </Container>
    )
  }
}

InstaImage.defaultProps = {
  products: []
}

InstaImage.propTypes = {
  image: PropTypes.string.isRequired,
  products: PropTypes.array,
  createNewPoint: PropTypes.func.isRequired,
  activePointIndex: PropTypes.number.isRequired,
  setActivePoint: PropTypes.func.isRequired
}

export default InstaImage



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/tagProducts/InstaImage.js